export default __webpack_public_path__ + "static/media/businessmeeting.f5f7cf1f.png";